<template>
    <div id="app">
        <page-container>
            <landscape-blocker />
            <custom-cursor v-if="!hasTouchSupport" />
            <background-shape />
            <site-header />
            <experience-principles-nav />
            <video-modal />
            <ar-modal />
            <scroll-container ref="fullpage" />
        </page-container>
    </div>
</template>

<script>
    import PageContainer from '../components/PageContainer.vue';
    import LandscapeBlocker from '../components/LandscapeBlocker.vue';
    import CustomCursor from '../components/CustomCursor.vue';
    import BackgroundShape from '../components/BackgroundShape.vue';
    import SiteHeader from '../components/SiteHeader.vue';
    import ScrollContainer from '../components/ScrollContainer.vue';
    import ExperiencePrinciplesNav from '../components/sections/experience-principles/ExperiencePrinciplesNav.vue';
    import VideoModal from '../components/VideoModal.vue';
    import ArModal from '../components/ArModal.vue';

    export default {
        name: 'Home',
        components: {
            PageContainer,
            LandscapeBlocker,
            CustomCursor,
            BackgroundShape,
            SiteHeader,
            ExperiencePrinciplesNav,
            ScrollContainer,
            VideoModal,
            ArModal,
        },
        mounted() {
            var hasTouchSupport =
                'ontouchstart' in window ||
                (window.DocumentTouch && document instanceof window.DocumentTouch) ||
                navigator.maxTouchPoints > 0 ||
                window.navigator.msMaxTouchPoints > 0;

            if (hasTouchSupport) {
                document.body.classList.add('has-touch');
            } else {
                document.body.classList.add('no-touch');
            }

            this.$store.dispatch('updateTouchSupport', hasTouchSupport);
        },
        computed: {
            hasTouchSupport() {
                return this.$store.getters.hasTouchSupport;
            },
        },
    };
</script>
